import {
  strategicInsightResponseSchema,
  type StrategicInsightResponse,
} from '@/features/benchmarking/schemas/benchmarkingStrategicInsights';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export type GetBenchmarkingStrategicInsightParams = { turmaId: number };

/**
 * Insight estratégico de uma turma.
 *
 * O endpoint é por turma (e não por escola) porque a geração via IA leva dezenas de
 * segundos: pedir a escola inteira numa requisição estouraria o timeout do gateway.
 */
export const getBenchmarkingStrategicInsight = httpGetAdapter<
  StrategicInsightResponse,
  GetBenchmarkingStrategicInsightParams
>({
  url: (params) => `/v3/microdados/turma/${params.turmaId}/insights-estrategicos`,
  schema: strategicInsightResponseSchema,
});
